import { MDBAnimation, MDBCard, MDBCardBody, MDBCardImage, MDBCardText, MDBCol, MDBContainer, MDBIcon, MDBPagination, MDBPaginationItem, MDBPaginationLink, MDBRipple, MDBRow } from "mdb-react-ui-kit"
import { useEffect, useState, createContext, useContext } from "react"
import { Link, Outlet } from 'react-router'

import { NewsContext } from '../../News/News'

export const NewsContent = () => {

    const newContext = useContext(NewsContext)

    const news = newContext?.news

    const newsList = newContext?.newsList

    // const pageHandler = () => newContext?.pageHandler()

    const index = newContext?.index

    const pager = newContext?.pager

    const pagerList = newContext?.pagerList

    const pagerIndex = newContext?.pagerIndex

    if (news === undefined) {
        return null
    }

    if (newsList === undefined) {
        return null
    }

    if (index === undefined) {
        return null
    }

    if (pager === undefined) {
        return null
    }

    if (pagerList === undefined) {
        return null
    }

    if (pagerIndex === undefined) {
        return null
    }


    return (
        <>
            <MDBContainer style={{ backgroundColor: '#1B5E20' }} className={'border border-0 border-danger bg-gradient'}>
                <MDBContainer className={'border border-0 border-danger d-flex align-items-center mt-5 text-white h1'}>
                    NEWS
                </MDBContainer>
                <MDBContainer className={'border border-0 border-success py-5'}>
                    <MDBRow className={'border border-0 border-warning g-4 mb-3'}>

                        {newsList?.map(
                            (val, index) => (
                                <MDBCol key={index} sm={12} md={4}>

                                    <Link to={`news_detail/${index}`}>
                                        <MDBAnimation reset={true} animation={'pulse'} start={'onHover'}>
                                            <MDBCard>
                                                <MDBRipple rippleColor='light' rippleTag='div' className='bg-image hover-overlay'>
                                                    <MDBCardImage className={'border border-0 border-danger w-100'} style={{ height: '200px' }} src={val.img} fluid alt='...' />
                                                    <a>
                                                        <div className='mask' style={{ backgroundColor: 'rgba(251, 251, 251, 0.15)' }}></div>
                                                    </a>
                                                </MDBRipple>
                                                <MDBCardBody>
                                                    <MDBCardText className={'border border-0 border-danger '}>
                                                        <div style={{height:'50px'}} className={'border border-0 border-danger text-wrap text-truncate'}>
                                                            {val.heading}
                                                        </div>
                                                            <small className='text-muted'>
                                                                <MDBIcon far icon="calendar-alt" />{val.date}
                                                            </small>
                                                    </MDBCardText>
                                                </MDBCardBody>
                                            </MDBCard>
                                        </MDBAnimation>
                                    </Link>
                                </MDBCol>
                            )
                        )}
                    </MDBRow>
                    {
                        news.length > 9 ? (

                            <MDBRow className={'border border-0 border-danger d-flex align-items-center'}>
                                <nav className={'border border-0 border-warning'} aria-label='...'>
                                    <MDBPagination end className='mb-0'>
                                        {
                                            pagerIndex > 0 ? (
                                                <MDBPaginationItem>
                                                    <MDBPaginationLink onClick={() => newContext?.pageBack()} href="#!" className={'text-warning'} tabIndex={-1} aria-disabled='true'>
                                                        <i className={"fas fa-angles-left"}></i>
                                                    </MDBPaginationLink>
                                                </MDBPaginationItem>
                                            )
                                                : ''
                                        }

                                        {

                                            pagerList.map(
                                                (val, i) => (


                                                    <MDBPaginationItem key={i} className={'border border-0 border-danger'}>
                                                        <MDBPaginationLink onClick={() => newContext?.pageHandler(val)} href="#!" style={{ cursor: 'pointer' }} className={'text-warning border border-0 border-danger'} >{val}</MDBPaginationLink>
                                                    </MDBPaginationItem>


                                                )
                                            )

                                        }

                                        {
                                            pagerIndex === (pager.length - 1) ?
                                                '' :
                                                (
                                                    <MDBPaginationItem>
                                                        <MDBPaginationLink onClick={() => newContext?.pageForward()} className={'text-warning'} href='#!'>
                                                            <i className={"fas fa-angles-right"}></i>
                                                        </MDBPaginationLink>
                                                    </MDBPaginationItem>
                                                )
                                        }

                                    </MDBPagination>
                                </nav>
                            </MDBRow>
                        ) : ''
                    }
                </MDBContainer>
            </MDBContainer>
        </>
    )
}